<template>
  <div>
    <b-table striped hover small outlined :items="passagesResultats" :fields="passagesFields" sort-by="Clt"
      id="tableau-resultats" responsive>
      <!-- TEMPLATE ROW NATION -->
      <template slot="cell(Nat)" slot-scope="data">
        <img :src="'https://sportips.fr/live/img/Flags/' + data.item.nation + '.jpg'
          " />
      </template>



      <!-- TEMPLATE ROW AVEC COULEURS -->
      <template v-for="(colored_field, index) in colored_fields" :slot="'cell(' + colored_field + ')'" slot-scope="data">
        <span
          :style="{ color: data.item.sexe === 'F' ? '#800080' : data.item.sexe === 'M' ? '#000080' : '#215b0c', fontWeight: 'bold' }">{{
            data.item[colored_field] }} </span>
      </template>

      <!-- TEMPLATE ROW TEMPS -->
      <template slot="cell(Temps)" slot-scope="data">
        <span class="temps_tab">{{ data.item.temps_arrondi }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  components: {},


  data() {
    return {
      selectedCoureur: {},
      show_modal: false,
    };
  },
  computed: {
    passagesResultats() {
      return this.$store.getters["event/listResultatsPassageFiltered"];

    },
    passagesFields() {
      return this.$store.getters["event/listFieldsPassage"];
    },
    colored_fields() {
      return this.$store.state.event.data.colored_fields;
    },
    diplome() {
      return this.$store.state.event.data.diplome;
    },
    nom_epreuve() {
      return this.$store.state.event.data.nom_epreuve;
    },
  },
  methods: {

  },
};
</script>

<style scoped>
.btn-informations svg {
  font-size: 10px;
  height: 10px;
}

.diploma-dl-btn:hover .diploma-icon {
  filter: invert(59%) sepia(62%) saturate(1607%) hue-rotate(1deg) brightness(98%) contrast(96%);
}

.diploma-icon {
  filter: invert(100%) sepia(2%) saturate(7466%) hue-rotate(261deg) brightness(124%) contrast(100%);
}
</style>
